export const PENNYLANE_MODAL_ERROR_STATUSES = [409, 422, 502];

export function openPennylaneLink(url) {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
}

export function readModules(rawModules) {
    if (typeof rawModules !== 'string') return rawModules ?? {};

    try {
        return JSON.parse(rawModules) ?? {};
    } catch {
        return {};
    }
}

export function readPennylane(quote) {
    return readModules(quote?.metadata?.modules)?.pennylane ?? null;
}
